<template>
  <div>
    <div class="block block_wide">
      <div class="block__item block__intro">
        <div class="block__intro-item block__intro-item_md">
          <router-link
            class="link link_inherit"
            :to="{ name: 'Members', hash: '#eventsNav' }"
          >
            <h2>
              {{ $t('event.nav.members') }}
              <sup class="color-muted">
                <b>{{ membersTotalCount }}</b>
              </sup>
            </h2>
          </router-link>
        </div>
        <div class="block__intro-item">
          <div
            class="members"
            v-if="members"
          >
            <router-link
              v-if="membersCount > 7"
              class="members__item members__item_more"
              :to="{ name: 'Members', hash: '#eventsNav' }"
            >
              <avatar
                username=""
                :size="36"
              >
              </avatar>
              <icon
                class="members__item-more"
                icon-name="more-horizontal"
              >
              </icon>
            </router-link>
            <div class="members__item"
               v-for="item in members"
               :key="item.Id"
            >
              <avatar
                :username="item.LastName + ' ' + item.FirstName"
                :size="36"
              >
              </avatar>
            </div>
          </div>
          <div class="members" v-else>
            <div
              class="members__item"
              v-for="i in 8"
              :key="i"
            >
              <skeleton :circle="true" width="36px" height="36px"></skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventsService from '@/services/eventsService';
import { Skeleton } from 'vue-loading-skeleton';
import Avatar from '@/components/Avatar.vue';

export default {
  name: 'EventMembers',
  components: {
    Avatar,
    Skeleton,
  },
  data() {
    return {
      members: null,
      membersCount: null,
      membersTotalCount: null,
    };
  },
  mounted() {
    eventsService.getRaceMembers({
      EventCode: this.$route.params.code,
      Count: 8,
      Offset: 0,
    })
      .then((res) => {
        const { data } = res;
        this.membersCount = data.RaceMembers.Items.length;
        this.members = data.RaceMembers.Items.splice(0, 7);
        this.membersTotalCount = data.RaceMembers.TotalCount;
      });
  },
};
</script>

<style lang="scss">
  .members {
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    justify-content: flex-end;

    &__item {
      flex: 0 0 auto;
      border-radius: 50%;
      overflow: hidden;
      border: 2px solid #ffffff;
      position: relative;
      margin-left: -8px;
      text-decoration: none;

      &:last-child {
        margin-left: 0;
      }

      &_more {

        &::after {
          content: "";
          position: absolute;
          background: $color-black-65;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }

        .user-avatar__img {
          display: none;
        }
      }
    }

    &__item-more {
      display: none;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 18 / 36 * 100%;
      height: 18 / 36 * 100%;
      color: $color-white;
      transform: translate(-50%, -50%);
      z-index: 1;

      .members__item_more & {
        display: block;
      }
    }
  }
</style>
